

































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "billable-entities-component": () =>
      import("@/components/app/global/client/billableEntitiesComp.vue"),
    "client-profile-fields": () =>
      import("@/components/app/global/client/clientProfileFields.vue"),
    "client-emails-component": () =>
      import("@/components/app/global/client/clientEmailsComp.vue"),
    "client-phones-component": () =>
      import("@/components/app/global/client/clientPhonesComp.vue")
  }
})
export default class ClientOverview extends Vue {
  @Prop({ required: true })
  public client!: IClient;

  public get clientId() {
    return this.client?.id;
  }
}
